import { reportError } from '@ms/yammer-telemetry';
import { setIsBackgroundLoad } from '@ms/yammer-telemetry-support';
import { persistRingId } from '@ms/yammer-web-support/dist/metaOsHub/persistRingInfo';
import { CrossAppDeepLink, getDeepLinkTargetPath, parseDeepLink } from '@ms/yammer-web-support/dist/teams/deeplinks';
import { getContext } from 'teams/context';

import { persistAppNameKey } from '../../../persistedState';
import { teamsContextStore } from '../../../state/teamsContext';

import { reportDeepLinkUsageEvent } from './deepLinkEvents';

const getDeepLinkPath = (subEntityId: string | undefined) => {
  if (!subEntityId) {
    return;
  }

  try {
    const crossAppDeepLink = CrossAppDeepLink.parse(subEntityId);

    if (crossAppDeepLink != null) {
      crossAppDeepLink.reportUsageEvent();

      return crossAppDeepLink.getTargetPath();
    }

    const deepLinkDetails = parseDeepLink(subEntityId);
    reportDeepLinkUsageEvent(deepLinkDetails);

    return getDeepLinkTargetPath({
      targetType: deepLinkDetails.entityType,
      targetInstance: deepLinkDetails.entityId,
      deepLinkType: deepLinkDetails.type,
    });
  } catch (error: unknown) {
    reportError({
      error,
      eventProperties: {
        errorCode: 'TeamsDeepLinkHandleFailed',
      },
    });
  }
};

type LoadContext = () => void;
export const loadContext: LoadContext = async () => {
  try {
    const context = await getContext();
    const deepLinkPath = getDeepLinkPath(context.subEntityId);

    setIsBackgroundLoad(!!context.isBackgroundLoad);
    persistRingId(persistAppNameKey, context.ringId);

    teamsContextStore.getState().setTeamsContext({
      locale: context.locale,
      theme: context.theme,
      hostClientType: context.hostClientType,
      hostAppName: context.hostAppName,
      entityId: context.entityId,
      deepLinkPath,
      userClickTime: context.userClickTime,
      appSessionId: context.appSessionId,
      ringId: context.ringId,
      appLaunchId: context.appLaunchId,
      isBackgroundLoad: context.isBackgroundLoad,
      userId: context.userId,
      tenantId: context.tenantId,
      loginHint: context.loginHint,
      sessionId: context.sessionId,
      chatId: context.chatId,
      manifestVersion: context.manifestVersion,
    });
  } catch (error: unknown) {
    reportError({
      error,
      eventProperties: {
        errorCode: 'GetTeamsContextFailed',
      },
    });
    throw error;
  }
};
